import { useEffect, useRef, useState } from 'react';

export default function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

// Drop-in useState replacement that persists the value in sessionStorage,
// so list pages keep pagination/search/filters across navigation. Cleared
// when the tab closes.
export function usePersistedState(storageKey, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (raw === null) return initialValue;
      return JSON.parse(raw);
    } catch {
      return initialValue;
    }
  });

  const keyRef = useRef(storageKey);
  useEffect(() => {
    keyRef.current = storageKey;
  }, [storageKey]);

  useEffect(() => {
    try {
      sessionStorage.setItem(keyRef.current, JSON.stringify(value));
    } catch {
      // ignore (private mode, quota exceeded, etc.)
    }
  }, [value]);

  return [value, setValue];
}
